import fieldNames from './field-names';
import {
  resolvePageTitle,
  resolveOpenGraphTitle,
  resolveOpenGraphDescription,
  resolveCanonicalUrl,
} from '../helpers/resolve-seo-values';

// `derive` is the UI value a checked flag stands for (shown in the disabled paired field)
const SEO_FLAG_PAIRS = {
  [fieldNames.USE_PAGE_NAME_FOR_PAGE_TITLE]: {
    valueField: fieldNames.TITLE,
    derive: resolvePageTitle,
  },
  [fieldNames.USE_PAGE_TITLE_FOR_OG_TITLE]: {
    valueField: fieldNames.OG_TITLE,
    derive: resolveOpenGraphTitle,
  },
  [fieldNames.USE_PAGE_DESCRIPTION_FOR_OG_DESCRIPTION]: {
    valueField: fieldNames.OG_DESCRIPTION,
    derive: resolveOpenGraphDescription,
  },
  [fieldNames.USE_PAGE_URL_FOR_CANONICAL_URL]: {
    valueField: fieldNames.CANONICAL_URL,
    derive: resolveCanonicalUrl,
  },
};

export default SEO_FLAG_PAIRS;
